// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { AlertCircle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconAlertCircle(props: any) {
    return <IconBase icon={AlertCircle} {...props} />
  }

  export default IconAlertCircle
  